import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Servidor } from 'src/app/modules/admin/models/Servidor';
import { SnackBarService } from 'src/app/services/snack-bar.service';
import { HelperService } from 'src/app/utils/helper.service';
import { ServidorService } from '../servidor.service';
import { AdminService } from 'src/app/modules/admin/admin.service';

@Component({
  selector: 'app-edit-servidor',
  templateUrl: './edit-servidor.component.html',
  styleUrls: ['./edit-servidor.component.css']
})
export class EditServidorComponent implements OnInit {

  servidorForm: FormGroup;
  orgao = false;
  loading = false;

  orgaos = [];
  orgaosLoading = false;
  servidor : Servidor;

  constructor(
    public dialogRef: MatDialogRef<EditServidorComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private servidorService: ServidorService,
    private adminService: AdminService,
    public helper: HelperService,
    private snackBar: SnackBarService,
    private fb: FormBuilder
  ) { }
  ngOnInit(): void {
    this.servidorForm = this.fb.group({
      cpf: [{ value: null, disabled: true }],
      vinculo: [null, Validators.required],
      nome: [null, Validators.required],
      dataNascimento: [null, Validators.required],
      email: [null, [Validators.required, Validators.email]],
      telefone: ['', Validators.required],
      genero: [null, Validators.required],
      origem: [null, Validators.required],
      orgaoLotacao: [null, Validators.required],
    });
    this.getOrgaoList();

    const servidorId = typeof this.data === 'object' ? this.data.id : this.data;

    this.servidorService.buscaServidor(servidorId)
      .subscribe((res: Servidor) => {
        this.servidor = res;
        this.loadServidorData(this.servidor);

        if (this.data.dadosRHNet) {
          this.preencherDadosRHNetSeVazio(this.data.dadosRHNet);
        }

        this.loading = false;
      },
        error => {
          this.loading = false;
          this.snackBar.showSnackBarError('Erro ao carregar dados do servidor');
          console.error(error);
          this.dialogRef.close();
        })
  }

  preencherDadosRHNetSeVazio(dados: any) {
    const telefone = this.extrairTelefone(dados.telefones);
    const genero = dados.siglaSexo === 'M' ? 'MASCULINO' : dados.siglaSexo === 'F' ? 'FEMININO' : null;

    const valores: any = {};

    if (!this.servidorForm.get('nome')?.value && dados.nome) {
      valores.nome = dados.nome;
    }
    if (!this.servidorForm.get('dataNascimento')?.value && dados.dataNascimento) {
      valores.dataNascimento = dados.dataNascimento;
    }
    if (!this.servidorForm.get('email')?.value && dados.email) {
      valores.email = dados.email;
    }
    if (!this.servidorForm.get('telefone')?.value && telefone) {
      valores.telefone = telefone;
    }
    if (!this.servidorForm.get('genero')?.value && genero) {
      valores.genero = genero;
    }

    if (Object.keys(valores).length > 0) {
      this.servidorForm.patchValue(valores);
    }
  }

  extrairTelefone(telefones: any[]): string | null {
    if (!telefones || telefones.length === 0) {
      return null;
    }

    for (const tel of telefones) {
      if (tel.tipoTelefoneDesc === 'celular') {
        return tel.ddd + tel.numero;
      }
    }

    return telefones[0] ? telefones[0].ddd + telefones[0].numero : null;
  }
  getOrgaoList() {
    this.orgaosLoading = true;
    this.servidorForm.controls.orgaoLotacao.disable();
    this.adminService.listarOrgaos()
      .subscribe((orgaos: any[]) => {
        this.orgaos = orgaos;
        this.orgaosLoading = false;
        this.servidorForm.controls.orgaoLotacao.enable();
      },
        error => {
          console.error(error);
          this.orgaosLoading = false;
          this.servidorForm.controls.orgaoLotacao.enable();
        });
  }
  compareWithOrgao(o1: any, o2: any) {
    return o1.id === o2;
  }
  loadServidorData(data) {
    this.servidorForm.patchValue(data);

    if (data.vinculos && data.vinculos.length > 0) {
      const vinculoAtivo = data.vinculos.find((v: any) => v.ativo) || data.vinculos[data.vinculos.length - 1];
      const origemNome = vinculoAtivo?.empresaNome
        || vinculoAtivo?.orgao?.origem?.nome
        || null;

      const vinculoTipoPorCargo: Record<number, string> = {
        1000000: 'TERCEIRIZADO',
        1000001: 'CEDIDO',
        1000002: 'EFETIVO',
        1000003: 'COMISSIONADO',
        1000004: 'CONTRATO_TEMPORARIO',
      };

      this.servidorForm.patchValue({
        origem: origemNome,
        vinculo: vinculoTipoPorCargo[vinculoAtivo?.cargo?.codigo] || null,
        orgaoLotacao: vinculoAtivo?.orgao?.lotacao || null,
      });
    }
  }

  closeDialog() {
    this.dialogRef.close({
      id: this.servidor.id,
      cpf: this.servidor.cpf,
      nome: this.servidorForm.value.nome,
      dataNascimento: this.helper.formatarData(this.servidorForm.value.dataNascimento),
      email: this.servidorForm.value.email,
      telefone: this.servidorForm.value.telefone,
      genero: this.servidorForm.value.genero,
      vinculo:
        {
          tipo: this.servidorForm.value.vinculo,
          orgaoLotacaoId: this.servidorForm.value.orgaoLotacao.id,
          origemNome: this.servidorForm.value.origem,
        }
    });
  }
}
